const getSelectedFiles = state => state.selectedFiles;

export default {
    getSelectedFiles
};
